// import

import type {GetStaticProps} from 'next';

import {revalidate} from 'libs/constants';
import db from 'libs/db';
import {compactNode} from 'libs/db/utils';
import type {PostNode, HomeMainNode} from 'libs/model';
import {HomePage} from 'modules/Home';

// types

type Props = {
  main: HomeMainNode;
  posts: PostNode[];
};

// component

export default function HomeView(props: Props) {
  const {main, posts} = props;

  return (
    <HomePage main={main} posts={posts} />
  );
}

// data

export const getStaticProps: GetStaticProps<Props> =
  async ({preview}) => {
    const [main, posts] = await Promise.all([
      db.readHomeMain({preview}),
      db.readPosts(undefined, {preview}),
    ]);

    if (!main) {
      return {notFound: true};
    }

    return {
      revalidate,
      props: {
        main,
        posts: posts
          .filter((n) => n.meta.bannerImage)
          .slice(0, 8)
          .map(compactNode),
      },
    };
  };
